module.exports = __webpack_public_path__ + "img/learn.123d119e.png";